// @givmo/app-charity — auth-resolution splash.
//
// Shown ONLY for the brief window between app mount and the first `onAuthStateChanged` emission
// (i.e. while `auth.isReady === false`). It exists to close the cold-load auth race: on a hard
// refresh into a protected route, Firebase rehydrates a persisted session ASYNCHRONOUSLY, so
// `auth.currentUser` is `null` for a moment. Gating the router on `isReady` means the guard only ever
// runs against a RESOLVED session, so an authed cold-load lands on its route and a genuinely
// signed-out cold-load still ends up at /login-home. (Parity with the admin app's AuthSplash.)

import { testIdProp } from '@givmo/design-system';

export function AuthSplash() {
  return (
    <div
      className="flex min-h-screen items-center justify-center bg-surface-sunken"
      {...testIdProp('charity-auth-splash')}
    >
      {/* B10: the spin is the only thing on the screen, so a caller who has asked for reduced motion
          gets a static ring rather than nothing — the role=status still announces the wait. */}
      <span
        role="status"
        aria-label="Loading"
        className="size-[32px] animate-spin rounded-full border-2 border-brand-500 border-t-transparent motion-reduce:animate-none"
      />
    </div>
  );
}
